import React, {useId} from 'react';
import {ChevronLeft, ChevronRight} from 'lucide-react';
import {bilingualTermTitle} from './termNavigation.js';

export default function TermNavigation({term, previous, next, titleVisible, onNavigate, className = '', showTitle = true, hidden = false, inactive = false}) {
  const id = useId();
  const title = bilingualTermTitle(term);
  function control(destination, direction) {
    const Icon = direction === 'previous' ? ChevronLeft : ChevronRight;
    const label = direction === 'previous' ? '上一個詞彙' : '下一個詞彙';
    const description = destination ? label + '：' + bilingualTermTitle(destination) : label + '：已到此分類' + (direction === 'previous' ? '第一個' : '最後一個') + '詞彙';
    const tooltipId = id + '-' + direction;
    return <span className={'term-navigation-control term-navigation-' + direction}>
      {destination ? <a href={'?term=' + encodeURIComponent(destination.id)} aria-label={description} aria-describedby={tooltipId} onClick={event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        onNavigate(destination);
      }}><Icon size={18} aria-hidden="true" /></a> : <button type="button" disabled aria-label={description}><Icon size={18} aria-hidden="true" /></button>}
      <span id={tooltipId} className="term-navigation-tooltip" role="tooltip">{description}</span>
    </span>;
  }
  return <nav className={'term-navigation ' + className} aria-label="同分類詞彙導航" hidden={hidden} inert={inactive} aria-hidden={inactive || undefined}>
    {control(previous, 'previous')}
    {showTitle && <span className={'term-navigation-title' + (titleVisible ? ' is-visible' : '')} aria-hidden={!titleVisible} title={title}>{title}</span>}
    {control(next, 'next')}
  </nav>;
}
